import Vue from 'vue';

const ACCESS_TOKEN_KEY = 'tjweb-access-token';
const REFRESH_TOKEN_KEY = 'tjweb-refresh-token';
const CASE_PREVIEW_KEY = 'tjweb-case-preview';

// 令牌放在 Vue.observable 里，组件的 computed 读取时自动建立依赖，
// localStorage 只作为刷新页面后的持久化载体
const authState = Vue.observable({
  accessToken: localStorage.getItem(ACCESS_TOKEN_KEY) || '',
  refreshToken: localStorage.getItem(REFRESH_TOKEN_KEY) || ''
});

// 获取访问令牌
export function getAccessToken() {
  return authState.accessToken;
}

// 获取刷新令牌
export function getRefreshToken() {
  return authState.refreshToken;
}

// 兼容旧调用：判断是否已登录时使用
export function getToken() {
  return getAccessToken();
}

// 设置令牌，入参为 yudao /system/auth/login 返回的 { accessToken, refreshToken }
export function setToken(data) {
  if (!data || !data.accessToken) {
    return;
  }
  authState.accessToken = data.accessToken;
  localStorage.setItem(ACCESS_TOKEN_KEY, data.accessToken);
  if (data.refreshToken) {
    authState.refreshToken = data.refreshToken;
    localStorage.setItem(REFRESH_TOKEN_KEY, data.refreshToken);
  }
}

// 清除令牌（不做页面刷新，避免 401 -> reload -> 401 的死循环）
export function removeToken() {
  authState.accessToken = '';
  authState.refreshToken = '';
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
}

// ========== 案例预览标记 ==========

export function enableCasePreview() {
  sessionStorage.setItem(CASE_PREVIEW_KEY, '1');
}

export function hasCasePreview() {
  return sessionStorage.getItem(CASE_PREVIEW_KEY) === '1';
}

export function clearCasePreview() {
  sessionStorage.removeItem(CASE_PREVIEW_KEY);
}
